import {KTCard} from 'src/_metronic/helpers'
import {ListViewProvider} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {TransactionsListHeader} from './components/header/TransactionsListHeader'
import {TransactionsTable} from './table/TransactionsTable'

const TransactionsList = () => {
  return (
    <>
      <KTCard>
        <TransactionsListHeader />
        <TransactionsTable />
      </KTCard>
    </>
  )
}

const TransactionsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <TransactionsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {TransactionsListWrapper}
